<template>
  <Header_en/>
  <Team_index_en></Team_index_en>
  <Team_index_bar_en></Team_index_bar_en>
  <router-view/>
  <br>
  <footer_en/>

</template>

<script>
import Header_en from "@/components/EN/Header_en";
import Team_index_en from "@/components/EN/team/Team_index_en";
import Footer_en from "@/components/EN/Footer_en";
import Team_index_bar_en from "@/components/EN/team/Team_index_bar_en";

export default {
  name: 'Team_en',
  components: {Footer_en, Header_en, Team_index_bar_en, Team_index_en},

}

</script>